import { applyMiddleware, compose, createStore as createReduxStore } from 'redux';
import thunk from 'redux-thunk';
import createSagaMiddleware from 'redux-saga';
import makeRootReducer from './reducers';
import rootSaga from '../sagas';

const composeEnhancers =
  window.__DEV__ && typeof window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ === 'function'
    ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    : compose;

const sagaMiddleware = createSagaMiddleware();

const createStore = (initialState = {}) => {
  const middleware = [sagaMiddleware, thunk];

  const enhancers = composeEnhancers(applyMiddleware(...middleware));
  const store = createReduxStore(makeRootReducer(), initialState, enhancers);
  store.asyncReducers = {};

  // Run saga
  sagaMiddleware.run(rootSaga);

  if (module.hot) {
    module.hot.accept('./reducers', () => {
      const reducers = require('./reducers').default;
      store.replaceReducer(reducers(store.asyncReducers));
    });
  }
  window.store = store;
  return store;
};

export default createStore;



// WEBPACK FOOTER //
// ./app/javascript/customer_chat/store/createStore.js